var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"form__button",attrs:{"to":_vm.buttonLink}},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t(_vm.text)))]),_c('span',{staticClass:"btn-text"},[_vm._v(_vm._s(_vm.$t(_vm.buttonText)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }